/**
 * AnalysisDataItem - Individual toggleable item in the analysis sidebar.
 *
 * Represents a single data series (parameter, dosing chemical, or event type)
 * that can be toggled on/off for inclusion in the analysis chart.
 */
import { Switch, Group, Text } from '@mantine/core';

interface AnalysisDataItemProps {
  /** The raw key/identifier for this item (used for selection state) */
  itemKey: string;
  /** Display label (if different from itemKey) */
  label?: string;
  /** Optional icon to display before the label */
  icon?: React.ReactNode;
  /** Whether this item is currently selected */
  checked: boolean;
  /** Callback when the item is toggled */
  onChange: (checked: boolean) => void;
}

export function AnalysisDataItem({
  itemKey,
  label,
  icon,
  checked,
  onChange,
}: AnalysisDataItemProps): JSX.Element {
  const displayLabel = label || itemKey;

  return (
    <Group justify="space-between" py={4}>
      <Group gap={8} wrap="nowrap">
        {icon}
        <Text size="sm">{displayLabel}</Text>
      </Group>
      <Switch
        checked={checked}
        onChange={(event) => onChange(event.currentTarget.checked)}
        aria-label={displayLabel}
        size="sm"
      />
    </Group>
  );
}
